<template>
	<div class="page-content wrapper">
		<transition name="fadeIn">
			<div class="page-content__container" v-if="Object.keys(articlesData).length > 0" :key="dataReady">
				<article-view :content-data="articlesData"></article-view>

				<footer-comp></footer-comp>
			</div>

			<div v-else class="loading-page" :key="dataReady">
				<loader :label="routeName"></loader>
			</div>
		</transition>
	</div>
</template>

<script>
	import { common } from '~components/common'
	import contentMixin from '~mixins/ContentType'

	export default {
		name: 'page-type',
		mixins: [contentMixin],
		components: common
	}
</script>



// WEBPACK FOOTER //
// src/vue/components/content-type/Page.vue?e0f38342